import React from 'react';
import { CSVLink } from 'react-csv';
import { CsvLinkBtn } from '../UI/CsvLinkBtn';


const UserDataExport = ({ userData }) => {
    const processUserDataForCsv = (data) => {
        return data.map(user => ({
            'Employee ID': user.employeeId,
            'First Name': user.firstName,
            'Last Name': user.lastName,
            'User Name': user.userName,
            'Email': user.email,
            'Phone': user.phone,
            'Gender': user.gender,
            'Blood Group': user.bloodGroup,
            'Birth Date': user.birthdate,
            'Marital Status': user.maritalStatus ? 'Married' : 'Single',
            'Father Name': user.fatherName,
            'Address': `${user.street}, ${user.city}, ${user.state}, ${user.zipCode}, ${user.country}`,
            'Permanent Address': `${user.pStreet}, ${user.pCity}, ${user.pState}, ${user.pZipCode}, ${user.pCountry}`,

            'Join Date': user.joinDate,
            'Leave Date': user.leaveDate,

            // Current Designation
            'Current Designation': user.designationHistory?.[0]?.designation?.name || 'N/A',

            // Current Salary
            'Current Salary': user.salaryHistory?.[0]?.salary || 'N/A',

            // Education Details
            'Education': user.educations?.map(edu =>
                `${edu.degree} - ${edu.institution} (${edu.fieldOfStudy})`
            ).join('; '),

            // Employment Status
            'Employment Status': user.employmentStatus?.name,

            // Department
            'Department': user.department?.name,

            // Role
            'Role': user.role?.name,

            // Shift
            'Shift': `${user.shift?.name} (${user.shift?.startTime?.slice(11, 16)} - ${user.shift?.endTime?.slice(11, 16)})`,

            // Leave Policy
            'Leave Policy': `${user.leavePolicy?.name} (Paid: ${user.leavePolicy?.paidLeaveCount}, Unpaid: ${user.leavePolicy?.unpaidLeaveCount})`,

            // Weekly Holiday
            'Weekly Holiday': `${user.weeklyHoliday?.startDay} to ${user.weeklyHoliday?.endDay}`,

            // Bank Details
            'Bank Details': user.bankDetails?.map(bank =>
                `${bank.bankName} - ${bank.accountNumber} - ${bank.IFSC_code}`
            ).join('; '),

        }));
    };

    const csvData = processUserDataForCsv(userData);

    return (
        <div>
            <CsvLinkBtn type="primary" className="flex items-center">
                <CSVLink
                    data={csvData}
                    filename={`employee_data_${new Date().toISOString().slice(0, 10)}.csv`}
                    className="text-white"
                >
                    Export to CSV
                </CSVLink>
            </CsvLinkBtn>
        </div>
    );
};

export default UserDataExport;